// URLs localizadas: ES sin prefijo, EN en /en/..., PT en /pt/... con segmentos traducidos.
// Las rutas internas de la app usan siempre la ruta ES ("esPath").
export const LANG_PREFIX = { ES: "", EN: "/en", PT: "/pt" };

const SEGMENTS = {
  modulos: { EN: "modules", PT: "modulos" },
  casos: { EN: "case-studies", PT: "casos" },
  glosario: { EN: "glossary", PT: "glossario" },
  "solicitar-demo": { EN: "request-demo", PT: "solicitar-demo" },
};

const SUBSLUGS = {
  modulos: {
    "farmacia-laboratorio": { EN: "pharmacy-laboratory", PT: "farmacia-laboratorio" },
    "monitoreo-remoto": { EN: "remote-monitoring", PT: "monitoramento-remoto" },
    administracion: { EN: "administration", PT: "administracao" },
    agenda: { EN: "scheduling", PT: "agenda" },
  },
  casos: {
    "ciprec-assessment-metricas": { EN: "ciprec-metrics-assessment", PT: "ciprec-avaliacao-metricas" },
    "cemic-escalando-protocolos": { EN: "cemic-scaling-protocols", PT: "cemic-escalando-protocolos" },
    "monitoreo-remoto-menos-visitas": { EN: "remote-monitoring-fewer-visits", PT: "monitoramento-remoto-menos-visitas" },
  },
  legal: {
    privacidad: { EN: "privacy", PT: "privacidade" },
    terminos: { EN: "terms", PT: "termos" },
    datos: { EN: "data-protection", PT: "protecao-de-dados" },
  },
};

// El blog (GoHighLevel) existe solo en español.
export const isSpanishOnly = (esPath) =>
  esPath === "/blog" || esPath.startsWith("/blog/") || esPath === "/evento" || esPath.startsWith("/evento/");

const reverse = (map, lang, value) => Object.keys(map).find((k) => map[k][lang] === value);

export function localizePath(to, lang) {
  if (!to || !to.startsWith("/") || lang === "ES" || !LANG_PREFIX[lang]) return to;
  const m = to.match(/^([^?#]*)(.*)$/);
  const pathname = m[1] || "/";
  if (isSpanishOnly(pathname)) return to;
  const [seg, sub, ...rest] = pathname.split("/").filter(Boolean);
  const parts = [];
  if (seg) parts.push(SEGMENTS[seg]?.[lang] || seg);
  if (sub) parts.push(SUBSLUGS[seg]?.[sub]?.[lang] || sub);
  parts.push(...rest);
  const out = `${LANG_PREFIX[lang]}${parts.length ? `/${parts.join("/")}` : ""}`;
  return `${out || "/"}${m[2]}`;
}

export function parsePath(pathname) {
  const clean = pathname.replace(/\/+$/, "") || "/";
  const pm = clean.match(/^\/(en|pt)(\/.*)?$/);
  if (!pm) return { lang: null, esPath: clean };
  const lang = pm[1].toUpperCase();
  const [seg, sub, ...rest] = (pm[2] || "").split("/").filter(Boolean);
  const parts = [];
  const esSeg = seg ? reverse(SEGMENTS, lang, seg) || seg : null;
  if (esSeg) parts.push(esSeg);
  if (sub) parts.push((SUBSLUGS[esSeg] && reverse(SUBSLUGS[esSeg], lang, sub)) || sub);
  parts.push(...rest);
  return { lang, esPath: parts.length ? `/${parts.join("/")}` : "/" };
}
